import { useStatQuery } from '@famly/stat_use-stat-query';
import { FetchAbsenceSourcesQuery } from './fetch-absence-sources.query';
import { useUpdateAbsenceSourcesResult } from './use-update-absence-sources';
/**
 * Hook to fetch absence source settings for the hours per absence day modal.
 *
 * @param options - Apollo query options including variables with siteSetId.
 * @returns Query result with absence sources data and loading state.
 */
export const useFetchAbsenceSources = (options) => {
    const queryResult = useStatQuery(FetchAbsenceSourcesQuery, options);
    useUpdateAbsenceSourcesResult(result => {
        if (result) {
            queryResult.updateQuery(cached => {
                const mutationResult = result.staffhours.settings.updateAbsenceSources;
                if (cached.staffhours.settings.absenceSources) {
                    cached.staffhours.settings.absenceSources = {
                        ...cached.staffhours.settings.absenceSources,
                        absenceSourceMode: mutationResult.absenceSourceMode,
                        holiday: mutationResult.holiday,
                        sick: mutationResult.sick,
                        childSick: mutationResult.childSick,
                        absent: mutationResult.absent,
                    };
                }
                return cached;
            });
        }
    });
    return queryResult;
};
